import { IRouteResolver } from '../types';
import { ResolverType } from '../resolver-types.enum';

export interface DashboardValidationsRouteParams {
    validationTypeId: string;
}

export class DashboardValidationsRouteResolver implements IRouteResolver {
    public pattern: RegExp = /^\/my\/dashboard\/validations\/([a-zA-Z0-9_-]+)(?:\/([a-zA-Z0-9_-]+))?(?:\?.*)?$/;
    public type: ResolverType = ResolverType.DASHBOARD_VALIDATIONS;

    public resolve(match: RegExpMatchArray): DashboardValidationsRouteParams {
        // Si hay un segundo parámetro (bug temporal), usar el segundo
        // Si no, usar el primero como validationTypeId
        const validationTypeId: string = match[2] || match[1];

        return {
            validationTypeId
        };
    }
}
